import { gql } from '@apollo/client';
import changeDateRequestEventFragment from '@shared/fragments/changeDateRequestEventFragment';

const SAVE_CHANGE_DATE_REQUEST = gql`
  mutation SaveChangeDateRequest($requestData: AppraiserEventChangeDateRequestInput!) {
    saveChangeDateRequest(requestData: $requestData) {
      ...ChangeDateRequestEventFields
    }
  }

  ${changeDateRequestEventFragment}
`;

export default SAVE_CHANGE_DATE_REQUEST;
